import { MaskedLine, Eyebrow } from "@/components/Motion";

export default function PageHero({ eyebrow, titleLines, accentLast = true, copy, children }) {
    return (
        <section className="relative pt-36 md:pt-44 pb-14 md:pb-20 overflow-hidden">
            <div className="absolute inset-0 bg-grid-purp opacity-60" />
            <div className="absolute inset-0 bg-radial-purp" />
            <div className="relative max-w-7xl mx-auto px-5 md:px-8">
                <Eyebrow className="mb-6">{eyebrow}</Eyebrow>
                <h1 className="font-display font-extrabold uppercase leading-[0.92] text-5xl sm:text-6xl lg:text-7xl tracking-tight" data-testid="page-hero-title">
                    {titleLines.map((line, i) => (
                        <MaskedLine key={i} delay={0.12 * i}>
                            {accentLast && i === titleLines.length - 1 ? (
                                <span className="italic text-purp text-glow">{line}</span>
                            ) : (
                                line
                            )}
                        </MaskedLine>
                    ))}
                </h1>
                {copy && <p className="mt-7 max-w-2xl text-slate-400 text-base md:text-lg leading-relaxed">{copy}</p>}
                {children}
            </div>
        </section>
    );
}
